import Vue from 'vue';
import VueRouter from 'vue-router';
// Views
import Home from '../views/Home.vue';
import News from '../views/News.vue';
import Event from '../views/Event.vue';
import Login from '../views/Login.vue';
import Orders from '../views/Orders.vue';
import Landing from '../views/Landing.vue';
import Profile from '../views/Profile.vue';
import Scene from '../views/Scene.vue';

import Basket from '../views/Basket.vue';
import BasketTickets from '../views/Basket/Tickets.vue';
import BasketPlaces from '../views/Basket/Places.vue';
import BasketPayment from '../views/Basket/Payment.vue';
import BasketMessage from '../views/Basket/Message.vue';
import BasketInformations from '../views/Basket/Informations.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/events/:id',
    name: 'Event',
    component: Event,
  },
  {
    path: '/news/:slug',
    name: 'News',
    component: News,
  },
  {
    path: '/landing',
    name: 'Landing',
    component: Landing,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
  },
  {
    path: '/orders',
    name: 'Orders',
    component: Orders,
  },
  {
    path: '/basket',
    component: Basket,
    children: [
      {
        path: '',
        name: 'BasketTickets',
        component: BasketTickets,
      },
      {
        path: 'places',
        name: 'BasketPlaces',
        component: BasketPlaces,
      },
      {
        path: 'informations',
        name: 'BasketInformations',
        component: BasketInformations,
      },
      {
        path: 'payment',
        name: 'BasketPayment',
        component: BasketPayment,
      },
      {
        path: 'message',
        name: 'BasketMessage',
        component: BasketMessage,
      }
    ]
  },
  {
    path: '/multimedias',
    name: 'Scene',
    component: Scene,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // scrollBehavior() {
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    return { x: 0, y: 0 };
  }
});

export default router;
